import { Expose, Transform, Type } from 'class-transformer';

export enum HonorificPrefix {
  Monsieur = 'M.',
  Madame = 'Mme',
  Mademoiselle = 'Mlle',
}

export class Address {
  @Expose({ name: 'houseNumber', toPlainOnly: true })
  @Transform(({ value }) => value || '', { toPlainOnly: true })
  num?: string;
  @Expose({ name: 'addressLine1', toPlainOnly: true })
  line1?: string;
  @Expose({ name: 'addressLine2', toPlainOnly: true })
  @Transform(({ value }) => value || '', { toPlainOnly: true })
  line2?: string;
  @Expose({ name: 'houseName', toPlainOnly: true })
  @Transform(({ value }) => value || '', { toPlainOnly: true })
  complement?: string;
  postalCode: string;
  @Transform(({ value }) => value?.replace('(', '')?.replace(')', ''), {
    toPlainOnly: true,
  })
  city: string;
  country: string;
}

export class Fidelity {
  @Expose({ name: 'loyaltySchemeMembershipNumber' })
  number?: string;

  @Expose({ name: 'loyaltySchemeName' })
  name?: string;
}

export class Customer {
  @Expose({ name: 'customerExternalId' })
  @Transform(({ value }) => `SQ_${value}`, { toClassOnly: true })
  id: string;
  @Expose({ name: 'customerId' })
  kfId: string;
  @Expose({ name: 'givenName' })
  firstname: string;
  @Expose({ name: 'familyName' })
  lastname: string;
  @Expose({ name: 'homeAddress' })
  @Type(() => Address)
  address?: Address;
  email: string;
  phoneNumber?: string;
  honorificPrefix?: HonorificPrefix;
  dateOfBirth?: string;

  @Expose({ name: 'loyaltySchemeMembership' })
  @Type(() => Fidelity)
  fidelity?: Fidelity;

  marketingConsent?: MarketingConsent;
}

export interface MetaData {
  totalSize: number;
  pageNumber: number;
  pageSize: number;
}

export interface Links {
  first: string;
  last: string;
  next: string;
  self: string;
}

export interface PagedCustomerResponse {
  customers: Customer[];
  meta: MetaData;
  links: Links;
}

export interface LiteMarketingChannel {
  channel: string;
  optIn: boolean;
}

export interface MarketingConsent {
  email: boolean;
  phone: boolean;
  post: boolean;
  sms: boolean;
}
